<div class="secure-viewer-container">
    <div class="viewer-header flex justify-between items-center p-2 bg-grey-10 border-b">
        <span class="text-sm font-semibold truncate">{{ data?.title || 'View Document' }}</span>
        <button mat-icon-button mat-dialog-close color="warn" matTooltip="Close" *ngIf="data && !isNewTab">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="viewer-content">
        <!-- Secure Iframe -->
        <iframe [src]="safeUrl" width="100%" height="100%" frameborder="0"
            style="user-select: none; -webkit-user-select: none;">
        </iframe>

        <!-- Overlay to prevent interaction if needed, though iframe handles content -->
        <div class="content-overlay" (contextmenu)="$event.preventDefault()"></div>
    </div>
</div>